import { createApi } from "@reduxjs/toolkit/query/react";
import { createAuthBaseQuery } from "../auth/reauthBaseQuery";
import { appConfig } from "../../appConfig";

export enum TagType {
  Account = "Account",
  Subscription = "Subscription",
  Discount = "Discount",
  Package = "Package",
  Duration = "Duration",
}

export const accountingApiSlice = createApi({
  reducerPath: "accountingApi",
  baseQuery: createAuthBaseQuery(appConfig.accountingUrl + "/api"),
  tagTypes: Object.values(TagType),
  keepUnusedDataFor: 3600,

  endpoints: (builder) => ({}),
});
